import { getBaseUrl } from '../utilities/constants';

export async function getSurveyData({ itemId, verifyKey }) {
	try {
		const requestResults = await fetch(`${getBaseUrl()}/v3/getSurveyData?&item_id=${encodeURIComponent(itemId)}&verify_key=${encodeURIComponent(verifyKey)}`);
		const objectData = await requestResults.json();
		if (requestResults.status > 199 && requestResults.status < 400) {
			return objectData;
		}
	} catch (err) {
		console.log('getSurveyData failed with error: ' + err);
	}

	return false;
}